module.exports = __webpack_public_path__ + "static/img/banner09.c8473d1f.png";